/**
 * Reseller Assets Page
 * File portal for reseller marketing materials and resources
 */

import React from 'react';
import { FileBrowser } from '../components/portal';
import '../styles/portal.css';
import './ResellerAssets.css';

const ResellerAssets = () => {
  return (
    <div className="rf-reseller-assets">
      <FileBrowser />
    </div>
  );
};

export default ResellerAssets;
